var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32Envelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.991 25H5.00901C3.89998 25 3 24.1009 3 22.9909V9.00906C3 7.89906 3.89998 7 5.00901 7H26.991C28.101 7 29 7.89906 29 9.00906V22.9909C29 24.1009 28.101 25 26.991 25Z",
    stroke: "#0A7E85",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03229 11.4449L13.6213 18.0339C14.8913 19.3039 16.9503 19.3039 18.2203 18.0339L24.8103 11.4449",
    stroke: "#0A7E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6544 16.067L7.03241 20.689",
    stroke: "#0A7E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1876 16.067L24.8106 20.689",
    stroke: "#0A7E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Envelope);
export default __webpack_public_path__ + "static/media/icon32_envelope.c98d4d4f2888d793dca598b87ef3072f.svg";
export { ForwardRef as ReactComponent };